import {AfterViewInit, Directive, ElementRef, EventEmitter, Input, OnInit, Output} from "@angular/core";

const dispatchChangeEvent = (targetInput) => {
  let event;
  if ("createEvent" in document) {
    event = document.createEvent("HTMLEvents");
    event.initEvent("input", false, true);
  } else {
    event = new Event("input");
  }
  event["onlySymbols"] = true;
  targetInput.dispatchEvent(event);
};


const pasteInSelection = (targetInput, str: string, filterFunc: (str: string) => string): boolean => {
  const filteredStr = filterFunc(str);
  const startPos = targetInput.selectionStart;
  const endPos = targetInput.selectionEnd;
  const front = (targetInput.value).substring(0, startPos);
  const back = (targetInput.value).substring(endPos, targetInput.value.length);
  targetInput.value = filterFunc(front + filteredStr + back);

  const newEndPos = startPos + filteredStr.length;
  targetInput.selectionStart = newEndPos;
  targetInput.selectionEnd = newEndPos;

  dispatchChangeEvent(targetInput);

  // return true if something was filtered out
  return str !== filteredStr;
};
const filterMobileInput = (targetInput, data: string, filterFunc: (str: string) => string): boolean => {
  const inputData = data ? data : "";
  const startPos = targetInput.selectionStart;
  const newValue = filterFunc(targetInput.value);
  let somethingFiltered = false;
  if (newValue !== targetInput.value) {
    somethingFiltered = true;
  }
  targetInput.value = newValue;
  const newEndPos = startPos - (inputData.length - filterFunc(inputData).length);
  targetInput.selectionStart = newEndPos;
  targetInput.selectionEnd = newEndPos;

  dispatchChangeEvent(targetInput);
  // return true if something was filtered out
  return somethingFiltered;

};

/**
 * Allow enter only symbols
 */
@Directive({
  selector: "[onlySymbols]"
})
export class OnlySymbolsDirective implements OnInit, AfterViewInit {

  @Input("onlySymbols") mask: string;
  @Input() inputMode: string; // it affects on mobile keyboard view
  @Output() onlySymbolsOnReplace = new EventEmitter();
  protected input: HTMLInputElement;

  constructor(protected el: ElementRef) {
  }

  ngOnInit(): void {
    this.input = this.el.nativeElement;
    if (this.input.tagName !== "INPUT" && this.input.tagName !== "TEXTAREA") {
      this.input = this.input.querySelector("input, textarea");
    }

    const leaveOnlyDigits = (str: string): string => str ? str.replace(new RegExp(this.mask, "gi"), "") : "";

    this.el.nativeElement.addEventListener("keydown", (e: KeyboardEvent) => {
      // Allow: backspace, delete, tab, escape, enter and .
      if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+C
        (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+V
        this.input && (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+X
        (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
        // let it happen, don't do anything
        return;
      }
      // Ensure that it is proper symbol and stop the keypress
      if (!leaveOnlyDigits(e.key).length) {
        e.preventDefault();
        this.onlySymbolsOnReplace.emit(true);
      }
    });

    const compositionListener = (e: CompositionEvent) => {
      if (!e["onlySymbols"]) {
        if (filterMobileInput(this.input, e.data, leaveOnlyDigits)) {
          this.onlySymbolsOnReplace.emit(true);
        }
      }
    };

    if (this.input) {
      this.el.nativeElement.addEventListener("paste", (e: ClipboardEvent) => {
        e.preventDefault();
        e.stopPropagation();

        const paste = (e.clipboardData || window["clipboardData"]).getData("text");
        if (pasteInSelection(this.input, paste, leaveOnlyDigits)) {
          this.onlySymbolsOnReplace.emit(true);
        }
      });
      this.el.nativeElement.addEventListener("input", compositionListener);
      this.el.nativeElement.addEventListener("compositionstart", compositionListener);
    }
  }

  ngAfterViewInit(): void {
    if (this.inputMode && this.input) {
      this.input.setAttribute("inputmode", this.inputMode);

      if (this.inputMode === "numeric") {
        this.input.pattern = "[0-9]*";
      }
    }
  }

}
